import { message } from "antd";
import { getToken, onMessage } from "firebase/messaging";
import { messaging, storage } from "./config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

// export const fetchToken = async () => {
//   // First, request permission
//   try {
//     await requestPermission(messaging);
//     try {
//       const currentToken = await getToken(messaging, {
//         vapidKey: process.env.REACT_APP_VAPID_KEY,
//       });
//       if (currentToken) {
//         return currentToken;
//       } else {
//         console.log(
//           "No registration token available. Request permission to generate one."
//         );
//         return null;
//       }
//     } catch (err) {
//       console.log("An error occurred while retrieving token. ", err);
//       return null;
//     }
//   } catch (err_1) {
//     console.log("Permission denied: ", err_1);
//     return null;
//   }
// };

// export const requestPermission = async () => {
//   // Request permission to receive notifications
//   const permission = await Notification.requestPermission();

//   // If the user granted permission
//   if (permission === "granted") {
//     console.log("Notification permission granted.");
//   } else {
//     message.error("Please enable browser notifications.")
//     throw new Error("Permission not granted");
//   }
// };

// Only implementing this because have to bypass the notifications for a facility
// if resolved by facility BOMC then remove this and use above commented
export const fetchToken = async () => {
  try {
    const hasPermission = await requestPermission();

    if (!hasPermission) return null;

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });

    return currentToken || null;
  } catch (err) {
    console.log("Error fetching token:", err);
    return null;
  }
};

export const requestPermission = async () => {
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    console.log("Notification permission granted.");
    return true;
  } else {
    console.warn("Notification permission denied.");
    return false;
  }
};

export const onMessageListener = (callback) => {
  return onMessage(messaging, callback);
};

export const uploadFileToFirebase = async (fileBlob, filename, bucketPath) => {
  try {
    if (!storage) {
      throw new Error("Firebase storage not initialized");
    }

    const storagePath = `${bucketPath}/${filename}`;

    const storageRef = ref(storage, storagePath);

    // upload
    const snapshot = await uploadBytes(storageRef, fileBlob);

    // get URL
    const downloadUrl = await getDownloadURL(snapshot.ref);

    return {
      file_name: filename,
      file_url: downloadUrl,
      storage_path: storagePath
    };

  } catch (error) {
    console.error("Firebase upload error:", error);
    throw error;
  }
};
